module.exports = {"ru":{"title":"Увеличить","close":"Закрыть"},"en":{"title":"Zoom in","close":"Close"}}